import { render, staticRenderFns } from "./info-affirm2.vue?vue&type=template&id=b72255e0&scoped=true&"
import script from "./info-affirm2.vue?vue&type=script&lang=js&"
export * from "./info-affirm2.vue?vue&type=script&lang=js&"
import style0 from "./info-affirm2.vue?vue&type=style&index=0&id=b72255e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72255e0",
  null
  
)

export default component.exports